var styles = {
  "unit-base": "4",
  "bullet-container-size": "16px",
  "carousel": "web_ui__Carousel__carousel",
  "content-container": "web_ui__Carousel__content-container",
  "content": "web_ui__Carousel__content",
  "navigation-container": "web_ui__Carousel__navigation-container",
  "bullet": "web_ui__Carousel__bullet",
  "active": "web_ui__Carousel__active",
  "far-neighbour": "web_ui__Carousel__far-neighbour",
  "neighbour": "web_ui__Carousel__neighbour",
  "clickable": "web_ui__Carousel__clickable",
  "navigation": "web_ui__Carousel__navigation",
  "floating": "web_ui__Carousel__floating",
  "arrow": "web_ui__Carousel__arrow",
  "left-arrow": "web_ui__Carousel__left-arrow",
  "right-arrow": "web_ui__Carousel__right-arrow",
  "outside": "web_ui__Carousel__outside",
  "outside-wide": "web_ui__Carousel__outside-wide"
};

export { styles as s };
//# sourceMappingURL=Carousel-e4b0046e.js.map
